"use client"

import { useLocation, Link } from "react-router-dom"
import { type Icon } from "@tabler/icons-react"

import { Badge } from "@/components/ui/badge"
import {
  SidebarGroup,
  SidebarGroupLabel,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from "@/components/ui/sidebar"

export function NavOrganization({
  items,
}: {
  items: {
    name: string
    url: string
    icon: Icon
    comingSoon?: boolean
  }[]
}) {
  const location = useLocation()

  return (
    <SidebarGroup className="group-data-[collapsible=icon]:hidden">
      <SidebarGroupLabel>Organization</SidebarGroupLabel>
      <SidebarMenu>
        {items.map((item) => (
          <SidebarMenuItem key={item.name}>
            <SidebarMenuButton asChild isActive={location.pathname === item.url}>
              <Link to={item.url}>
                <item.icon />
                <span>{item.name}</span>
                {item.comingSoon && (
                  <Badge variant="secondary" className="ml-auto text-[10px] px-1.5 py-0">
                    Soon
                  </Badge>
                )}
              </Link>
            </SidebarMenuButton>
          </SidebarMenuItem>
        ))}
      </SidebarMenu>
    </SidebarGroup>
  )
}
